import { render, staticRenderFns } from "./newLevel.vue?vue&type=template&id=498bfd8a&scoped=true&"
import script from "./newLevel.vue?vue&type=script&lang=js&"
export * from "./newLevel.vue?vue&type=script&lang=js&"
import style0 from "./newLevel.vue?vue&type=style&index=0&id=498bfd8a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498bfd8a",
  null
  
)

export default component.exports